import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  flag: false,
  message: ''
};

export const notificationSlice = createSlice({
  name: 'updateNotificationState',
  initialState,
  reducers: {
    setNotification: (state, action) => {
      state.flag = action.payload.flag;
      state.message = action.payload.message;
    }
  }
});

export const { setNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
